import styled from "styled-components";
import { AppBar, Box, ButtonBase, Grid, Button } from "@mui/material";

export const AppBarStyled = styled(AppBar)`
	box-shadow: none;
	padding: 10px;
`;

export const GradientBox = styled(Box)`
	padding: 10px;
	box-sizing: border-box;
	border-radius: 31px;
`;

export const GradientBox2 = styled(Box)`
	padding: 10px;
	box-sizing: border-box;
	border-radius: 31px;
`;

export const ItemContainer = styled(Grid)`
	width: 50%;
	margin: auto 0 auto auto;
`;

export const Item = styled(Grid)`
	font-family: 'Open Sans', sans-serif;
	font-weight: bold;
	font-size: 20px;
	color: #f4f5f9;
	text-align: center;
	padding: 5px 0;
	transition: opacity 500ms ease-out;
`;

export const HamburgerButtonStyled = styled(ButtonBase)`
	width: 45px;
	height: 45px;
	background: #ffffff;
	border-radius: 50%;
`;

export const DropDownButton = styled(Button)`
	margin-left: auto;
	color: #000000;
	font-weight: 400;
	font-size: 15px;
`;
